export default __webpack_public_path__ + "static/media/404.06fa84b1.gif";